import {
  PRODUCTS_ALREADY_CREATED_ESCROW_ACCOUNT,
  PRODUCTS_ESCROW_ACCOUNT,
  PRODUCTS_ESCROW_TRANSACTIONS,
  PRODUCTS_LIMIT_SOLICITATIONS,
} from '~/actions/actionTypes';

const initialState: reducers.ProductsReducer = {
  escrowAccount: null,
  escrowTransactions: null,
  alreadyCreatedEscrowAccount: false,
  limitSolicitations: null,
  countLimitSolicitations: null,
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const productsReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case PRODUCTS_ALREADY_CREATED_ESCROW_ACCOUNT:
      state = {
        ...state,
        alreadyCreatedEscrowAccount: action.payload,
      };
      break;

    case PRODUCTS_ESCROW_ACCOUNT:
      state = {
        ...state,
        escrowAccount: action.payload,
      };
      break;

    case PRODUCTS_ESCROW_TRANSACTIONS:
      state = {
        ...state,
        escrowTransactions: action.payload,
      };
      break;

    case PRODUCTS_LIMIT_SOLICITATIONS:
      state = {
        ...state,
        limitSolicitations: action.payload,
      };
      break;

    default:
      return state;
  }

  return state;
};

export default productsReducer;
